interface Options {
    search: string;
    filter: FilterOptions;
    sort: SortOptions;
}

const DEFAULT_OPTIONS: Options = {
    search: '',
    sort: {
        sortDirection: 'desc',
        sortKey: 'time_created',
    },
    filter: {
        showWaypoints: true,
        showTracks: true,
        showAreas: true,
        showRoutes: true,
        showHiddenItems: true,
        showVisibleItems: true,
        showFolders: true,
        activityCategories: [],
    },
};

export default DEFAULT_OPTIONS;
